import React from "react";
import "./styles.scss";
import { grievanceEmail } from "../../config/legalEmails";

const TesseractPortalAndroidTNC = () => {
  return (
    <>
      <div
        className="tnc-tesseractportal-android-wrapper"
        spellCheck="false"
        tabIndex={0}
        contentEditable="false"
      >
        <div className="tnc-tesseractportal-android-wrapper-info">
          <h3 id="tnc-tesseractportal-android-wrapper-inner">
            Terms of use&nbsp;
          </h3>
        </div>

        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li>
            This Terms of Use along with the Privacy Policy (“Terms”), is a
            binding agreement between Tesseract Imaging Limited
            (we/us/our/Tesseract) having its corporate office at Building No. 22,
             Reliance Corporate Park Ghansoli MIDC Industrial Area, Thane Belapur 
             Road, Navi Mumbai, Maharashtra, Thane (400701) and the end user who access or avail the
            Application (defined below) and the Content in accordance with this
            Terms (“you”/“your”) of the Application (defined below). The Terms
            are an electronic record in terms of the Information Technology Act,
            2000 (as amended / re-enacted) (“IT Act") and rules thereunder, and
            is published in accordance with the provisions of Rule 3 (1) (a) of
            Information Technology (Intermediary Guidelines and Digital Media
            Ethics code) Rules, 2021, which mandates for publishing of rules and
            regulations, privacy policy and terms of use for access or usage of
            Application. This electronic record is generated by a computer
            system and does not require any physical or digital signatures
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li>
            BY CLICKING ON THE “I ACCEPT”/ “SIGN IN” BUTTON AT THE END OF THE
            TERMS, OR OTHERWISE HAVING ACCESS TO, RECEIVING, AND/OR USING THE
            TESSERACT PORTAL APPLICATION (“APPLICATION”), YOU HEREBY CONFIRM TO
            HAVE READ, UNDERSTOOD AND AGREE TO BE GOVERNED AND BOUND BY, THIS
            TERMS AND THE PRIVACY POLICY (“POLICY”) WHICH IS INCORPORATED BY
            REFERENCE AND FORMS PART OF TERMS AND ANY OTHER RULES OR GUIDELINES,
            AS MAY BE ISSUED BY TESSERACT IMAGING LIMITED WITH RESPECT TO THE
            APPLICATION, FROM TIME TO TIME. YOU MAY ACCESS THE PRIVACY POLICY IN
            SUPPORT SECTION. SINCE ALL THE TERMS AND CONDITIONS AS MENTIONED
            HEREUNDER ARE PIVOTAL TO TESSERACT IMAGING LIMITED PROVIDING YOU
            ACESS TO THIS APPLICATION IF YOU DO NOT AGREE TO BE BOUND BY THE
            TERMS, PLEASE DO NOT CLICK THE “I ACCEPT” BUTTON OR DOWNLOAD OR
            INSTALL/USE THE APPLICATION.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li>
            Tesseract Imaging Limited reserves the right to modify the Terms at
            any time at its sole discretion, with notice to you. You will be
            deemed to have accepted the terms of these Terms, as amended, if you
            continue to access the Application after the Terms are modified and
            notified to you. Discontinuing use of this Application will not
            affect the applicability of the Terms to your prior uses of the
            Application
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li>
            You acknowledge and confirm that for purposes of the Application,
            Tesseract Imaging Limited is merely acting as a passive conduit to
            facilitate the availability of the Content and therefore Tesseract
            Imaging Limited is an intermediary under the Information Technology
            Act, 2000 as amended and the relevant rules made thereunder. This
            Terms is deemed to be published and shall be construed in accordance
            with the provisions of Information Technology (Intermediary
            Guidelines and Digital Media Ethics Code) Rules, 2021 under
            Information Technology Act, 2000 that require publishing the rules
            and regulations, privacy policy and user agreement for access or
            usage of the Content.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>1. Registration:</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            In order to access any information, Content to which you may have
            authorized access to as part of, or through your use of, the
            Application, you will be required to download and install the
            Application on your Device (defined below). This Application has
            been devised for usage along with the augmented reality, virtual
            reality and/ or mixed reality products of Tesseract and/ or its
            affiliates.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">2.&nbsp;</li>
          <li>
            If you are under the age of 18 years, you should review this Terms
            with your parent or legal guardian to make sure that you and your
            parent or legal guardian understand and agree to it and further if
            required your parent / legal guardian shall perform or undertake
            such activities to enter into a legally binding agreement with
            Tesseract Imaging Limite
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">3.&nbsp;</li>
          <li>
            In order to access and use the Content, you are required to create a
            user account with Tesseract Imaging Limited for the Application. You
            agree not to reveal your user account information to anyone. You are
            solely responsible for maintaining the confidentiality and security
            of your user account and for all activities that occur on or through
            your user account. You agree to immediately notify Tesseract Imaging
            Limited of any security breach of your user account. Tesseract
            Imaging Limited shall not be responsible for any losses arising out
            of the unauthorized use of your user account. You confirm and
            warrant that all the data and information supplied by you when you
            register for accessing the Application and provided by you to
            Tesseract Imaging Limited is true, current, complete and accurate in
            all respects
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">4.&nbsp;</li>
          <li>
            You may at the sole discretion of Tesseract Imaging Limited be
            permitted to write comments/reviews/feedback regarding the Content
            on social networking websites through the social networking
            capabilities incorporated in the Application. You shall not post any
            unlawful, threatening, abusive, libellous, defamatory, obscene,
            vulgar, pornographic, profane or indecent information of any kind,
            including, without limitation, any comments/reviews/feedback
            constituting or encouraging conduct that would constitute a criminal
            offence, give rise to civil liability or otherwise violate any
            local, state, national or international law or regulation. You give
            Tesseract Imaging Limited express rights and consent to display your
            rating / review in relation to the relevant Content on the
            Application/website, including making it available to other members
            for viewing. These features may change without notice to you and the
            degrees of associated information sharing and functionality may also
            change without notice.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">5.&nbsp;</li>
          <li>
            Tesseract Imaging Limited is free at its sole discretion to use any
            comments, information, ideas, concepts, reviews, or techniques or
            any other material contained in any communication you may send to us
            (“User Feedback”), including responses to questionnaires or through
            postings to the Application and user submissions, without further
            compensation, acknowledgement or payment to you for any purpose
            whatsoever including, but not limited to, developing, manufacturing
            and marketing products and creating, modifying or improving
            Tesseract Imaging Limited’s offerings including Application. By
            posting / submitting any User Feedback / user submission on the
            Application, you grant Tesseract Imaging Limited a perpetual,
            worldwide, non-exclusive, royalty-free irrevocable, sub-licensable
            license and right in such User Feedback / user submission to
            Tesseract Imaging Limited, including the right to display, use,
            reproduce, or modify the User Feedback / user submission in any
            media, software or technology of any kind now existing or developed
            in the future. Tesseract Imaging Limited reserves the right to
            remove User Feedback / user submission at sole discretion and/or
            upon on request of any third party that such User Feedback / user
            submission may create liability for Tesseract Imaging Limited or
            harm the reputation of Tesseract Imaging Limited or are offensive,
            inappropriate, defamatory, obscene or libelous in nature.
          </li>
        </ul>

        {/* 2nd */}
        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>2. Grant of License</strong>
          </li>
        </ul>

        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            Software License: You hereby agree that all rights, title and
            interests in the Application vest with Tesseract Imaging Limited or
            its licensors. Subject to your strict and full compliance with the
            Terms, Tesseract Imaging Limited hereby grants you a revocable,
            non-exclusive, non-transferable, non-sub-licensable, limited
            license, to download, install and use the Application on Devices
            owned and controlled by you, and to access and use the Content only
            through the Application on such Devices, strictly in accordance with
            the terms of these Terms. The Application includes (i) the software
            application in object code/source code that you may access and
            download and the scripts, interfaces, graphics, displays, text,
            documentation and other components/associated data and information
            made available to you as part of the software; and (ii) any updates,
            modifications, or enhancements to (i) or any part thereof, as may be
            provided by Tesseract Imaging Limited
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">2.&nbsp;</li>
          <li>
            Content License: “Content” shall include all visual and audio-visual
            works, including all interactive content, texts, photographs,
            mini-applications etc., made available to you through the
            Application for enterprise use-cases. The Content is either owned by
            Tesseract Imaging Limited or by third party content providers as
            indicated on the Application. Subject to your strict and full
            compliance with the Terms and the relevant terms of the third party
            content providers, Tesseract Imaging Limited, hereby grants you for
            the territory of India a personal, limited, non-exclusive,
            non-transferable, revocable license to use the Content through your
            Device in accordance with the Terms and the relevant terms of the
            third party content providers.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">3.&nbsp;</li>
          <li>
            Except for the rights expressly stated herein, no other rights are
            granted to you with respect to the Application or the Content,
            either by implication, estoppel, or otherwise
          </li>
        </ul>

        {/*  3rd */}
        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>
              3. Terms of Accessing the Application and the Content:
            </strong>
          </li>
        </ul>

        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            The Application is merely intended as a means to make the Content
            available. Your access to the Application and the Content signifies
            your consent to view / receive all such Content. You agree and
            acknowledge that by use of the Application, you do not acquire
            ownership in the Application or the Content. You shall view the
            Content only by way of streaming/download or any other functionality
            provided by the Application only. You agree to view and use the
            Content strictly in the manner permitted under this Terms and the
            relevant terms of the third party content providers.
          </li>
        </ul>

        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">2.&nbsp;</li>
          <li>
            Application and all Content, including all text, graphics,
            trademarks, logos, photographs, audio visual content, and other
            material made available through the Application constitutes material
            proprietary to Tesseract Imaging Limited or its content providers as
            indicated on the Application, and is protected by applicable
            intellectual property laws, and may not be used by You, except as
            permitted by Tesseract Imaging Limited
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">3.&nbsp;</li>
          <li>
            Use of the Application requires: (i) compatible devices such as
            smart phones powered by Android (“Device”), (ii) compatible
            product(s) made available by Tesseract Imaging Limited and/ or its
            affiliates, and (iii) internet access. Further, certain software
            (fees may apply), in your Device or in the Application may require
            periodic updates and use of the Application along with its
            performance may be affected by the performance of these factors.
            High-speed internet access is strongly recommended for regular use.
            The latest version of the Application is recommended to access the
            Content and may be required for certain transactions or features.
            You agree that meeting these requirements, which may change from
            time to time, is your responsibility
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">4.&nbsp;</li>
          <li>
            From time to time, and without prior notice to you, Tesseract
            Imaging Limited may provide updates of the Application, or may issue
            upgraded versions of the Application. However, Tesseract Imaging
            Limited shall be under no obligation to do so. All updates/upgrades
            provided by Tesseract Imaging Limited will be subject to the terms
            of this Terms.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">5.&nbsp;</li>
          <li>
            The Application may contain the links or pointers to other websites
            or mini-applications but you should not infer or assume that
            Tesseract Imaging Limited operates, controls, or is otherwise
            connected with these other websites or mini-applications, unless
            otherwise expressly provided. When you click on a link within the
            Application, Tesseract Imaging Limited may not warn you that you
            have left the Application and are subject to the terms and
            conditions (including privacy policies) of another website or
            mini-application. Please be careful to read the terms of use and
            privacy policy of any other website or mini-application before you
            provide any confidential information or engage in any transactions.
            You should not rely on this Terms to govern your use of another
            website or other mini-applications provided under this Application.
            Tesseract Imaging Limited is not responsible for the content or
            practices of any other website or mini-application even if it links
            to the Application or even if the website is operated by a company
            affiliated or otherwise connected with Tesseract Imaging Limited,
            unless otherwise expressly provided. You acknowledge and agree that
            Tesseract Imaging Limited is not responsible or liable to you for
            any content or other materials hosted and served from any website
            other than the Application
          </li>
        </ul>

        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>
              4. Restrictions on use of the Application and the Content{" "}
            </strong>
          </li>

          <ul className="tnc-tesseractportal-android-wrapper-content">
            <li role="presentation">1.&nbsp;</li>
            <li>
              You shall use the Application strictly in accordance with this
              Terms and shall not: (i) decompile, disassemble, reverse engineer
              or attempt to derive the source code of or in any manner decrypt
              the Application; (ii) make any modification, adaptation or
              improvement, enhancement, or derivative work from the Application
              or incorporate any portion of the software into your own programs
              or compile any portion of it in combination with your own
              programs, transfer it for use with another service; (iii) violate
              any applicable laws or regulations including but not limited to
              copyright act, import and export control laws and regulations in
              connection with your access or use of the Application or the
              Content; (iv) remove or obscure any proprietary notice (including
              any notice of copyright or trademark) forming a part of the
              Application or the Content; (v) use the Application or the Content
              for offering hosting services to a third party, or any other
              purpose for which it is not designed or intended; (vi) install,
              use or permit the Application to exist on more than one Device at
              a time or on any other applicable device, other than by means of
              your separate downloads of the Application, each of which is
              subject to a separate license; (vii) distribute or link the
              features being provided to multiple devices, or other features;
              (viii) make available the Application over a network or other
              environment permitting access or use by multiple users at the same
              time or where it could be used by multiple devices at the same
              time, whether or not the same is for commercial use; (ix) use the
              Application for data mining, scraping, crawling, redirecting, or
              for any purpose not in accordance with the terms of these Terms;
              (x) use the Application to attempt to interfere with the proper
              display of the Content; (xi) use the Application for undertaking
              any hacking activities like breaching or attempt to breach the
              security of another user or attempt to gain access to any other
              person's computer, software or data without the knowledge and
              consent of such person; (xii) use the Application for creating a
              service or software that is directly or indirectly, competitive
              with the Application or any features offered by Tesseract Imaging
              Limited; or (xiii) derive any confidential information, processes,
              data or algorithms from the Application.
            </li>
          </ul>
        </ul>

        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">2.&nbsp;</li>
          <li>
            You also expressly agree not to engage in any use or activity that
            (a) may interrupt, destroy, alter, damage, delay, or limit the
            functionality or integrity of the Application or the Content
            including that of, any associated software, hardware,
            telecommunications or wireless equipment; (b) may manipulate
            identifiers, or numeric information to disguise the origin of any
            user, device, material or other information; (c) may interfere with
            the proper working of the Application or prevent others from using
            the Application; or (d) may delete the copyright and other
            proprietary rights notices on the Application
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">3.&nbsp;</li>
          <li>
            You agree not to use the Application for any activity relating to
            infringement of any intellectual property rights, including any
            trademarks, service marks, or trade names, privacy rights,
            personality rights, or any other proprietary rights of any third
            party. You shall not use the Application and access the Content
            through the Application outside the territory of the Republic of
            India, unless permitted by Tesseract Imaging Limited. Tesseract
            Imaging Limited shall have the right to use various technologies and
            digital rights management mechanisms to enforce this territorial
            restriction and/or to verify your compliance with this restriction
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">4.&nbsp;</li>
          <li>
            Nothing contained herein shall be construed or implied to grant any
            right or license to use any trademarks, trade names, service marks
            or logos, which are a part of the Application or the Content,
            without the prior written consent of the owner of rights in such
            marks
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">5.&nbsp;</li>
          <li>
            You agree not to incorporate the Content into, or stream or
            retransmit the Content via, any hardware or software application or
            make it available via frames or in-line links unless expressly
            permitted by Tesseract Imaging Limited.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">6.&nbsp;</li>
          <li>
            You shall not access the Content by any means other than through the
            Application. You shall, unless explicitly provided herein, neither
            directly nor through the use of any device, software, web-based
            service, or other means copy, download, stream capture, reproduce,
            duplicate, archive, distribute, upload, publish, / re-publish,
            modify, translate, broadcast, perform, publicly display, sell,
            transmit or retransmit, edit, re-use,adapt, incorporate or create
            any derivative works of, any Content streamed / viewed / downloaded
            from the Application.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">7.&nbsp;</li>
          <li>
            You must not access the Application if you are a person who is
            either barred or otherwise legally prohibited from receiving or
            using the services under the Application or any services under the
            laws of India.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">8&nbsp;</li>
          <li>
            You shall not host, display, upload, modify, publish, transmit,
            update or share any information on Application or any other links
            available on Application, which:
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(a)&nbsp;</li>
              <li role="presentation">
                Belongs to another person and to which you do not have any right
                to;
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(b)&nbsp;</li>
              <li role="presentation">
                Is grossly harmful, harassing, blasphemous, defamatory, obscene,
                pornographic, pedophilic, libelous, invasive of another’s
                privacy, hateful, or racially, ethnically objectionable,
                disparaging, relating or encouraging money laundering or
                gambling or otherwise unlawful in any manner whatsoever; or
                unlawfully threatening or unlawfully harassing including but not
                limited to “indecent representation of women” within the meaning
                of the Indecent Representation of Women (Prohibition) Act 1986
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(c)&nbsp;</li>
              <li role="presentation">Is misleading in any way;</li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(d)&nbsp;</li>
              <li role="presentation">
                Is patently offensive to the online community, such as sexually
                explicit content, or content that promotes obscenity,
                paedophilia, racism, bigotry, hatred or physical harm of any
                kind against any group or individual;
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(e)&nbsp;</li>
              <li role="presentation">
                Harassing or advocates harassment of another person;
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(f)&nbsp;</li>
              <li role="presentation">
                Involves the transmission of "junk mail", "chained letters", or
                unsolicited mass mailing or "spamming";
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(g)&nbsp;</li>
              <li role="presentation">
                Promotes illegal activities or conduct that is abusive,
                threatening, obscene, defamatory or libellous;
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(h)&nbsp;</li>
              <li role="presentation">
                Infringes upon or violates any third party rights (including,
                but not limited to, intellectual property rights, rights of
                privacy or rights of publicity);
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(i)&nbsp;</li>
              <li role="presentation">
                Promotes an illegal or unauthorized copy of another person
                copyrighted work;
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(j)&nbsp;</li>
              <li role="presentation">
                Provides instructional information about illegal activities such
                as making and/ or buying illegal weapons, violating someone
                privacy, or providing or creating computer viruses;
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(k)&nbsp;</li>
              <li role="presentation">
                Solicits gambling or engages in any gambling activity which we
                in our sole discretion believe is or could be construed to be as
                illegal;
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(l)&nbsp;</li>
              <li role="presentation">Harms minors in any way;</li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(m)&nbsp;</li>
              <li role="presentation">
                Violates any law for the time being in force;
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(n)&nbsp;</li>
              <li role="presentation">Impersonates another person;</li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(o)&nbsp;</li>
              <li role="presentation">
                Contains software viruses or any other computer code, files or
                programs designed to interupt, destroy or limit the
                functionality of any computer resource; or contains any trojan
                horses, worms, time bombs, cancelbots, easter eggs or other
                computer programming routines that may damage, detrimentally
                interfere with, diminish value of, surreptiously intercept or
                expropriate any system, data or personal information.
              </li>
            </ul>
            <ul className="tnc-tesseractportal-android-wrapper-content">
              <li role="presentation">(p)&nbsp;</li>
              <li role="presentation">
                Threatens the unity, integrity, defence, security or sovereignty
                of India, friendly relations with foreign states, or public
                order or causes incitement to the commission of any cognizable
                offense or prevents investigation of any offense or is insulting
                any other nation;
              </li>
            </ul>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">9.&nbsp;</li>
          <li>
            You agree not to, or permit anyone else to, circumvent, disable or
            otherwise interfere with security-related features and any digital
            rights management mechanisms of the Application including the
            features that prevent or restrict use or copying of any Content
            provided to you through the Application. You agree that Tesseract
            Imaging Limited shall have no liability for, and you agree to
            defend, indemnify and hold Tesseract Imaging Limited harmless
            against, any claims, losses or damages arising out of, or in
            connection with, your unauthorized use of any Content and/or
            Application.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">10.&nbsp;</li>
          <li>
            Tesseract Imaging Limited does not endorse any Content made
            available through the Application, or any opinion, recommendation,
            or advice expressed thereon by any user and Tesseract Imaging
            Limited expressly disclaims any and all liability in connection with
            such views or opinions or comments provided by the users.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">11.&nbsp;</li>
          <li>
            Tesseract Imaging Limited shall use reasonable efforts to make the
            Content available to the users, at all times through the
            Application. However, the Content is provided over the internet,
            data and cellular networks and so the quality and availability of
            the same may be affected by factors outside Tesseract Imaging
            Limited’s control. Accordingly, Tesseract Imaging Limited does not
            accept any responsibility for unavailability of the Application
            and/or Content, at any time. Tesseract Imaging Limited will not be
            responsible for any support or maintenance for the Application.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">12.&nbsp;</li>
          <li>
            Part of the Application may contain advertising information or
            promotion material or other material submitted to Tesseract Imaging
            Limited by third parties. Responsibility for ensuring that material
            submitted for inclusion on the Application complies with applicable
            national law is exclusively on the party providing the
            information/material. Your correspondence or business dealings with,
            or participation in promotions of advertisers including payment and
            delivery of related goods or services, and any other terms,
            conditions, warranties or representations associated with such
            dealings, are solely between you and such advertiser. Before relying
            on any advertising material, you should independently verify its
            relevance for your purpose, and should obtain appropriate
            professional advice. Tesseract Imaging Limited shall not be
            responsible nor liable for any loss or claim that you may have
            against an advertiser or any consequential damages arising on
            account of you relying on the contents of the advertisement.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">13.&nbsp;</li>
          <li>
            TESSERACT IMAGING LIMITED DISCLAIMS ANY AND ALL RESPONSIBILITY FOR
            ANY DISCLOSURE OF INFORMATION OR ANY OTHER PRACTICES OF ANY THIRD
            PARTY. TESSERACT IMAGING LIMITED EXPRESSLY DISCLAIMS ANY WARRANTY
            WITH RESPECT TO YOUR PERSONAL OR OTHER INFORMATION THAT MAY BE
            COLLECTED, PROCESSED, SHARED OR RETAINED BY ANY THIRD PARTY.
          </li>
        </ul>

        {/* 5th  */}
        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>5. Fees</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            The Application may be downloaded through an online store/e-store as
            per the terms and conditions applicable for such download including
            this Terms.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">2.&nbsp;</li>
          <li>
            You hereby agree that for getting access to any Content, you may be
            required to pay the requisite fees to Tesseract Imaging Limited or
            the relevant third party content provider, as per the separate
            written agreement/ documentation entered into by you or by your
            organization on your behalf with Tesseract Imaging Limited or the
            relevant third party content provider
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">3.&nbsp;</li>
          <li>
            -At the time of getting access to and your use of the Content, you
            agree to Tesseract Imaging Limited’s or the relevant third party
            content provider’s collection of the fees associated with the
            Content as selected by you, through the payment mode agreed by you
            with Tesseract Imaging Limited or the relevant third party content
            provider.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">4.&nbsp;</li>
          <li>
            By using this Application, you acknowledge that the Content
            available via the Application may be accessed through
            telecommunications/internet connection. You are responsible for the
            provision of, and payment for, telecommunications/internet services
            including, the relevant network or data charges, roaming charges or
            other costs or fees and for any other items of hardware or
            communications equipment necessary to enable you to access the
            subscribed features. Tesseract Imaging Limited will not be
            responsible, nor will you be entitled for any refunds of fees for
            unavailability of the Content due to disruption, unavailability, or
            failure in your telecommunications equipment or internet connection
            or other relevant services.
          </li>
        </ul>

        {/* 6th */}

        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>6. Rights of Tesseract Imaging Limited:</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            Tesseract Imaging Limited, in its sole discretion, may terminate or
            suspend your access to the Application and Content without any
            obligation to serve any prior notice and without any obligations or
            liabilities towards you or towards any third parties, except as
            provided under Clause 5.4 above.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">2.&nbsp;</li>
          <li>
            Upon your breach of this Terms, the Policy or any other restrictions
            or guidelines of Tesseract Imaging Limited for use of the
            Application and/or accessing any of the Content, Tesseract Imaging
            Limited reserves the right to take any responsive actions which
            Tesseract Imaging Limited may deem appropriate. Such actions may
            include (but may not be limited to) temporary or permanent removal
            of Content, termination of your immediate suspension or cancellation
            of your access to the Content via the Application
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">3.&nbsp;</li>
          <li>
            Tesseract Imaging Limited may take any other legal or technical
            action against you that Tesseract Imaging Limited may deem
            appropriate, including any action against offenders to recover the
            costs and expenses of identifying them.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">4.&nbsp;</li>
          <li>
            Tesseract Imaging Limited may directly or through third party
            service providers send information to you about the various services
            offered by Tesseract Imaging Limited from time to time.
          </li>
        </ul>

        {/* 7th */}

        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>7. Indemnity&nbsp;</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            You shall defend, indemnify and hold harmless, Tesseract Imaging
            Limited, its affiliates, any third party networks / infrastructure
            providers and their respective directors, officers, personnel,
            contractors and agents, for and against any and all claims, suits,
            judgment, losses, damages, cost and expenses arising or relating to
            your use of the Application and/or the Content or your breach of the
            terms of these Terms or the Policy or any other restrictions or
            guidelines provided by Tesseract Imaging Limited. This
            indemnification obligation will survive this Terms and Your use of
            the Application / Content.
          </li>
        </ul>

        {/* 8th */}
        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>8. Disclaimer of Warranties:</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            THE APPLICATION AND ALL CONTENT PROVIDED THROUGH THE APPLICATION, IS
            PROVIDED ON AN “AS-IS” AND “WITH ALL FAULTS AND RISKS” BASIS,
            WITHOUT WARRANTIES OF ANY KIND. TESSERACT IMAGING LIMITED DOES NOT
            WARRANT, EXPRESSLY OR BY IMPLICATION, THE ACCURACY OR RELIABILITY OF
            THE APPLICATION OR ANY CONTENT OR ITS SUSTAINABILITY FOR A
            PARTICULAR PURPOSE. TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE
            LAWS, TESSERACT IMAGING LIMITED DISCLAIMS ALL WARRANTIES WHETHER
            EXPRESS OR IMPLIED, INCLUDING THOSE OF MERCHANTABILITY, FITNESS FOR
            A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR THAT USE OF THE
            APPLICATION AND THE CONTENT OR ANY MATERIAL THEREOF WILL BE
            UNINTERRUPTED OR ERROR-FREE OR THAT ANY CONTENT WILL BE AVAILABLE
            THROUGHOUT TERM. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING,
            TESSERACT IMAGING LIMITED DOES NOT REPRESENT OR WARRANT THAT THE
            APPLICATION WILL RESULT IN COMPLIANCE, FULFILLMENT OR CONFORMITY
            WITH THE LAWS, REGULATIONS, REQUIREMENTS OR GUIDELINES OF ANY
            GOVERNMENT OR GOVERNMENTAL AGENCY.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">2.&nbsp;</li>
          <li>
            To the maximum extent permitted by applicable law, Tesseract Imaging
            Limited provides no warranty on use of the Content and shall not be
            liable for the same under intellectual property rights, libel,
            privacy, publicity, obscenity or other laws. Tesseract Imaging
            Limited also disclaims all liability with respect to the misuse,
            loss, modification or unavailability of any Content
          </li>
        </ul>

        {/* 9th */}
        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>9. Limitation of Liability:&nbsp;</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            YOU ASSUME THE ENTIRE RISK OF USING THE APPLICATION AND THE CONTENT.
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
            TESSERACT IMAGING LIMITED BE LIABLE TO YOU FOR ANY SPECIAL,
            INCIDENTAL, INDIRECT, PUNITIVE OR CONSEQUENTIAL DAMAGES WHATSOEVER
            (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF USE, LOSS OF
            BUSINESS PROFITS, BUSINESS INTERRUPTION, LOSS OF INFORMATION, OR ANY
            OTHER PECUNIARY LOSS) ARISING OUT OF THE USE OF, OR INABILITY TO USE
            OR ACCESS, THE APPLICATION OR THE CONTENT OR FOR ANY SECURITY BREACH
            OR ANY VIRUS, BUG, UNAUTHORIZED INTERVENTION, DEFECT, OR TECHNICAL
            MALFUNCTIONING OF THE APPLICATION, WHETHER OR NOT FORESEEABLE OR
            WHETHER OR NOT TESSERACT IMAGING LIMITED HAS BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES, OR BASED ON ANY THEORY OF LIABILITY,
            INCLUDING BREACH OF CONTRACT OR WARRANTY, NEGLIGENCE OR OTHER
            TORTIOUS ACTION, OR ANY OTHER CLAIM ARISING OUT, OF OR IN CONNECTION
            WITH, YOUR USE OF, OR ACCESS TO, THE APPLICATION OR THE CONTENT.
            FURTHER, TESSERACT IMAGING LIMITED SHALL NOT BE LIABLE TO YOU FOR
            ANY TEMPORARY DISABLEMENT, PERMANENT DISCONTINUANCE OR MODIFICATION
            OF THE APPLICATION BY TESSERACT IMAGING LIMITED OR FOR ANY
            CONSEQUENCES RESULTING FROM SUCH ACTIONS.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">2.&nbsp;</li>
          <li>
            TESSERACT IMAGING LIMITED’S AGGREGATE LIABILITY (WHETHER UNDER
            CONTRACT, TORT INCLUDING NEGLIGENCE, WARRANTY OR OTHERWISE) AND THAT
            OF ITS AFFILIATES SHALL BE LIMITED TO RUPEES HUNDRED (Rs. 100).
          </li>
        </ul>

        {/* 10th */}
        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>10. Governing Law:</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            This Terms is governed and construed in accordance with the laws of
            India. The courts in Mumbai shall have exclusive jurisdiction to
            hear disputes arising out of the Terms
          </li>
        </ul>

        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>11. Force Majeure:</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            Tesseract Imaging Limited shall be under no liability whatsoever in
            the event of non-availability of any portion of the Application or
            subscribed Content occasioned by act of God, war, disease,
            revolution, riot, civil commotion, strike, lockout, flood, fire,
            failure of any public utility, man-made disaster, infrastructure
            failure or any other cause whatsoever beyond the control of
            Tesseract Imaging Limited.
          </li>
        </ul>

        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>
              12. Copyright Notice and Notice for other Grievances:
            </strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            In accordance with the applicable laws, for any grievance including
            if, you believe in good faith that the Content or any information
            viewed through the Application infringes your copyright, you may
            reach us at {grievanceEmail}.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">2.&nbsp;</li>
          <li>
            You may forward your request/ complaints to Grievance Officer. Name: Mr. Jayant Pathak; Contact: +91-9321975699; E-mail: {grievanceEmail}
          </li>
        </ul>

        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>13. Waiver:</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            Any failure by Tesseract Imaging Limited to enforce the Terms, for
            whatever reason, shall not necessarily be construed as a waiver of
            any right to do so at any time.
          </li>
        </ul>

        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>14. Severability:</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            If any of the provisions of this Terms are deemed invalid, void, or
            for any reason unenforceable, that part of the Terms will be deemed
            severable and will not affect the validity and enforceability of any
            remaining provisions of the Terms.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>15. Entire Agreement</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            The Terms including the Policy, as amended from time to time,
            constitutes the entire agreement between the parties and supersedes
            all prior understandings between the parties relating to the subject
            matter herein.
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-ul_style">
          <li role="presentation">
            <strong>16. Limited Time To Bring Your Claim:</strong>
          </li>
        </ul>
        <ul className="tnc-tesseractportal-android-wrapper-content">
          <li role="presentation">1.&nbsp;</li>
          <li>
            You and Tesseract Imaging Limited agree that any cause of action
            arising out of or related to use of the Application or the Content
            must commence within one (1) year after the cause of action accrues
            otherwise, such cause of action will be permanently barred.
          </li>
        </ul>
      </div>
    </>
  );
};

export default TesseractPortalAndroidTNC;
